import useSWR from "swr";
import { customAuthAxios } from "../../utils/customAuthAxios";

export type KuchikomyuSetting = {
  id: string;
  restaurant: string;
  branch_score: number;
  g_url: string;
  en_url: string;
  default_url: string;
  default_en_url: string;
  qr_card_img?: string;
  en_qr_card_img?: string;
  unique_question: boolean;
}

const fetcher = (url: string) => customAuthAxios.get(url).then(res => res.data);

export const useKuchikomyuSettingFetcherKey = (settingsId?: string) =>
    settingsId ? `kuchikomyu/settings/${settingsId}` : null;

export const useFetchKuchikomyuSetting = (settingsId?: string) => {
  const fetcherKey = settingsId ? `kuchikomyu/settings/${settingsId}` : null;
  const { data: kuchikomyuSetting, error, isLoading } = useSWR<KuchikomyuSetting>(
      fetcherKey,
      fetcher,
      {
        revalidateOnMount: true,
        revalidateIfStale: true,
      }
  );
  return { kuchikomyuSetting, isLoading, error };
};